import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useQuery, gql } from '@apollo/client';

const Heading = styled.div`
  color: white;
  margin-top: 20px;
  font-family: "Questrial", sans-serif;
  font-weight: bold;
`;

const CommentWrapper = styled.div`
  margin-bottom: 30px;
  width: 90%;
  margin-left: 5%;
`;

const Comment = styled.div`
  color: white;
  font-style: italic;
  font-size: 14px;
  margin-left: 25px;
  margin-top: -5px;
`;

const CommentAuthor = styled.div`
  color: white;
  font-size: 16px;
  margin-top: 20px;
  font-family: "Questrial", sans-serif;
  &::after {
    content: ":";
  }
`;

const CommentListWrapper = styled.div`
  margin-bottom: -5px;
`;

const GET_COMMENTS = gql`
  query getComments($id: ID) {
    __typename
    comments(where: {contentId: $id}) {
      edges {
        node {
          content
          author {
            ... on CommentToCommenterConnectionEdge {
              node {
                name
              }
            }
          }
        }
      }
    }
  }
`;

const CommentList = ({ views, currentIndex }) => {
  const { id } = views[currentIndex];
  const { data } = useQuery(GET_COMMENTS, { variables: { id } });

  const comments = data && data.comments.edges.map(({ node: { content, author } }) => {
    const comment = content.replace(/^<p class="attachment[^\n]+\n/, '');
    return {
      comment,
      author,
    };
  });
  return (
    <div>
      {data && comments.length > 0 ? (
        <CommentListWrapper>
          <hr />
          <Heading>Comments:</Heading>
          <div>
            {data
              && comments.map(({ comment, author: { node: { name } } }) => (
                <CommentWrapper>
                  <CommentAuthor dangerouslySetInnerHTML={{ __html: name }} />
                  <Comment dangerouslySetInnerHTML={{ __html: comment }} />
                </CommentWrapper>
              ))}
          </div>
        </CommentListWrapper>
      ) : null}
    </div>
  );
};

export default CommentList;
